/*
* Si vous prenez la custom scrollbar, utilisez watchscoll.js pour
* votre librairie qui gère la visibilité d'une élément. 
* (scrollcontent.js n'est pas fait pour fonctionner avec la custom scrollbar)
*
* - Ajax ready
*/

// **---------------------------------------------------**
// -------------------------------------------------------
// Global variables BEGIN
var ScrollItems = [];
// Global variables END
// **---------------------------------------------------**
// -------------------------------------------------------


// **---------------------------------------------------**
// -------------------------------------------------------
// Object BEGIN
function ScrollItem(child) {
	c = child;
	/*
	* constructor
	*/
	this.block = c.block;
	this.active = false;
	this.ot = c.ot;
	this.ob = c.ob;
	this.height = c.height;
	// this.ps = c.positionScreen;
	// this.po = c.positionObject;
}
// Object END
// **---------------------------------------------------**
// -------------------------------------------------------


// **---------------------------------------------------**
// -------------------------------------------------------
// Prototype BEGIN
//init
ScrollItem.prototype.init = function() {
	/*
	* first we get all the .ToAnim
	*/
	var scrollitems = document.getElementsByClassName('ToAnim');

	var children = [];

	/*
	* loop through the scrollitems array and create an object with all it's properties
	*/
	for (var i = 0; i < scrollitems.length; i++) {
		var el = scrollitems[i];

		children[i] = [];
		child = children[i];

		/*
		* get the TextRectangle of the object
		*/
		rect = el.getBoundingClientRect();
		ot = rect.top;
		ob  = rect.bottom;

		/*
		* get positions infos
		*/
		// ps = el.dataset.screeny;
		// po = el.dataset.objecty;

		/*
		* set the value
		*/
		child['block'] = el;
		child['ot'] = ot;
		child['ob'] = ob;
		child['height'] = el.clientHeight;
		// child['positionScreen'] = ps;
		// child['positionObject'] = po;

		/*
		* create the ScrollItem object
		*/
		obj = new ScrollItem(child);

		/*
		* push the created object in the array
		*/
		ScrollItems.push(obj);
	}

	ScrollItem.prototype.watch();
}

// show
ScrollItem.prototype.show = function(i) {
	var index = i;

	/*
	* get the object with the index received
	*/
	var item = ScrollItems[index];
	item.active = true;

	var block = item.block;

	block.classList.add('IsAnim');
}

// hide
ScrollItem.prototype.hide = function(i) {
	var index = i;

	/*
	* get the object with the index received
	*/
	item = ScrollItems[index];
	item.active = false;

	block = item.block;

	block.classList.remove('IsAnim');
}

// watch
ScrollItem.prototype.watch = function() {
	/* we use this for loop to fix a bug when we remove an item from an array during
	*  a "normal" for loop : an item gets skipped
	*/
	for (var i = ScrollItems.length - 1; i >= 0; i--) {
		var item = ScrollItems[i];

		active = item.active;
		if (!active) {
			block = item.block;
			height = item.height;
			ot = item.ot;
			ob = item.ob;
			// po = item.po;
			// ps = item.ps;


			show = ( scrolled_y + screenHeight > (ot + (screenHeight / 4) ) );
			if (show) {
				ScrollItem.prototype.show(i);
				ScrollItem.prototype.remove(i);
			}
		}
	}
}

// remove
ScrollItem.prototype.remove = function(i) {
	ScrollItems.splice(i, 1);
}

// reset
ScrollItem.prototype.reset = function() {
	ScrollItems = [];
}

// update
ScrollItem.prototype.update = function() {
	// update items properties
}
// Prototype END
// **---------------------------------------------------**
// -------------------------------------------------------


// **---------------------------------------------------**
// -------------------------------------------------------
// Function BEGIN

// Function END
// **---------------------------------------------------**
// -------------------------------------------------------


/*
*** Available prototype
*
* ScrollItem.prototype.init();
*
** i: item index
*
* ScrollItem.prototype.watch();	
* ScrollItem.prototype.show(i);
* ScrollItem.prototype.hide(i);
* ScrollItem.prototype.remove(i)
*/


/*
* @TODO
* - change position of where the element trigger
* - update function (ot, ob, item height)
* - choose if an element can trigger more than once
* - groupe d'animation pour gérer l'ordre que les items trigger
*/